import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => createStyles({
    paper: {
        backgroundColor: theme.colors.structure.pageBackground,
    },
}));

export default useStyles;
